import { Modal } from "bootstrap";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const successToast = (message) => {
    window.store.dispatch('showSuccessModal', message);
};

export const errorToast = (message) => {
    window.store.dispatch('showErrorModal', message);
};

export const helper = {
    showLogin() {
        // window.router.push({name: 'login'})
        errorToast('Please Login to Access'); 
    },
    openModal(id) {
        setTimeout(() => {
            let modal = new Modal(id);
            modal.show();
        }, 100)
    },
    closeModal(id) {
        setTimeout(() => {
            let closeModal = document.getElementById(id)
            let modal = Modal.getInstance(closeModal);
            if(modal) {
                modal.hide();
            }
        }, 100)
    },
    formatNumber(value){
        if (value !== null) {
            return parseFloat(value).toFixed(2);
        } else {
            return 0;
        }
    },
    notNull(item){
        return item !== ('' || null || undefined)
    },
    formatTime(value) {
        return value < 10 ? `0${value}` : value;
    },
    compareLength: (len, prop) => {
        return prop.length == len
    },
    testRegex(regex, data) {
        return regex.test(data);
    },
    //----- sanitization helpers
    sanitizeDetails(field, prop, sliceLength) {
        let regexMap = {
            userId : /[^\S]/g,
            oldLoginUserId: /[\s]/g,
            password : /[^a-zA-Z0-9!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|`~=-]/g,
            login : /\s+/g,
            oldLoginPassword: /[\s]/g,
            referCode : /[^0-9]/g,
            withdrawPassword: /[\s]/g,
            chipName: /[^a-zA-Z0-9_]/g,
            onlySpace: /[^\S]/g,
        }
        return prop.replace(regexMap[field] , '').slice(0, sliceLength);
    },
    sanitizeNumber(prop, maxValue) {
        prop = prop?.toString() ?? '';
        let stringValue = prop.replace(/[^0-9]/g, '');
        if (stringValue === '') return '';

        // Truncate to 15 digits max
        const truncated = stringValue.slice(0, 15);

        // If maxValue is set and not a giant value, clamp it
        if (maxValue !== 9999999999999999) {
            const num = parseInt(truncated, 10);
            if (isNaN(num)) return '';
            return Math.min(num, maxValue).toString();
        }
        return truncated
    },
    getPaginationData(data) {
        return {
            currPage: data.current_page,
            from: data.from,
            to: data.to,
            lastPage: data.last_page,
            perPage: data.per_page,
            total: data.total,
        }
    },
    kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    },
    formatNumber(value) {
        if (value !== null) {
            return parseFloat(value).toFixed(2);
        } else {
            return 0;
        }
    },
    downloadExcel(data, fileName){
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, fileName);
    },
    downloadPdf(data, fileName) {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [Object.keys(data[0])],
            body: data.map((obj) => Object.values(obj)),
        });
        doc.save(fileName);
    },
    positive(val) {
        if (val < 0) {
          return val * -1;
        }
        return val;
    },
    addCommas(value) {
        if (!value) return "0";
        var value = parseFloat(value).toFixed(2);
        value += '';
        var x = value.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        var total = x1 + x2;
        return total;
    },
    checkDecimalNumber(value) {
        const num = Number(value);
        if (!value || Number.isNaN(num)) return '0';
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
    },
    currencyConverter(convertValue, currency = 1) {
        let currency_rates = {
            1: 1, 
            2: 2, 
            3: 0.01, 
            4: 0.01
        };
        return convertValue && currency_rates[currency] ? currency_rates[currency] * convertValue : convertValue;
    },
    isMobile() {
        let screenSize = window.innerWidth;
        let mobileView = 991;
        return screenSize<=mobileView
    },
    //----- sanitization helpers
}